<template>
  <div class="childPannel">
    <div v-if="list.length" class="childPannel-box">
      <div v-for="m in list" @click="handleClickItem(m)" :key="m.id" class="childPannel-box-item">
        <div class="childPannel-box-item-block">
          <div class="childPannel-box-item-block-info">
            <span class="childPannel-box-item-block-info-label">编号：</span>
            <span class="childPannel-box-item-block-info-value">{{ m.id }}</span>
          </div>
          <div class="childPannel-box-item-block-info">
            <span class="childPannel-box-item-block-info-label">名称：</span>
            <span class="childPannel-box-item-block-info-value">{{ m.name }}</span>
          </div>
        </div>
        <div class="childPannel-box-item-block">
          <div class="childPannel-box-item-block-info">
            <span class="childPannel-box-item-block-info-label">航标类型：</span>
            <span class="childPannel-box-item-block-info-value">{{ m.structure }}</span>
          </div>
        </div>
        <div class="childPannel-box-item-block">
          <div class="childPannel-box-item-block-info">
            <span class="childPannel-box-item-block-info-label">更新时间：</span>
            <span class="childPannel-box-item-block-info-value">2025-04-15 11:11</span>
          </div>
        </div>
      </div>
    </div>
    <el-empty v-if="!list.length" :image-size="100" description="当前内容为空" />
    <el-pagination
      class="childPannel-pagination"
      v-else
      size="small"
      v-model:current-page="params.pageNum"
      :page-size="params.pageSize"
      background
      :pager-count="5"
      @change="getList"
      layout="prev, pager, next"
      :total="total"
    />
  </div>
</template>

<script lang="ts" setup>
import { reactive, ref, watch } from 'vue'
import { toCameraPosition } from './utils'
import { LayerPopupCtrl } from '@/components/LayerPopupCtrl'
import { CesiumObj } from '@/components/GIS/CesiumObj'
import { Cartographic, Math } from 'cesium'
import MarkPopup from '../../Popup/MarkPopup.vue'
import { getMarkDataInfo } from '@/apiFzn'
import type { ImarkDetail } from '@/apiFzn/types'

import { useMarkStore } from '@/stores/navimark'
const usermarkStore = useMarkStore()

import { useBridgeStore } from '@/stores/bridge'
const useBriStore = useBridgeStore()

const popupCtrl = LayerPopupCtrl.getInstance();
let cesiumobj: CesiumObj | null = null

const handleClickItem = async (m: ImarkDetail) => {
  if (!cesiumobj) cesiumobj = await CesiumObj.getInstance()
  usermarkStore.openMarkDetail(m.id),
  useBriStore.closeDetail()
    popupCtrl.popupMap.forEach((val) => {
      val.destroy()
    })

  toCameraPosition({
    lng: m.longitude,
    lat: m.latitude,
  })
  const cartographic = Cartographic.fromDegrees(m.longitude, m.latitude, 0)
  popupCtrl.popup({
    viewer: cesiumobj.viewer,
    id: m.id,
    lnglat: [cartographic.longitude, cartographic.latitude].map(Math.toDegrees) as [number, number],
    Com: MarkPopup,
    properties: m,
  })
}

const props = defineProps({
  showPannelKey: {
    type: String,
    default: '',
  },
  searchValue: {
    type: String,
    default: '', // 提供默认值
  },
})

const params = reactive({
  name: '',
  pageNum: 1,
  pageSize: 8,
})

const list = ref<ImarkDetail[]>([])
const total = ref(0)

const getList = () => {
  getMarkDataInfo(params).then((res) => {
    list.value = res.rows
    total.value = res.total
  })
}

defineExpose({
  getList,
})

watch(
  () => props.searchValue,
  (newVal) => {
    params.name = newVal
    params.pageNum = 1
  },
  { immediate: true }
)
</script>

<style lang="scss" scoped>
@import url('./childPannel.scss');
</style>
